import { ComponentChildren } from "preact";

export function OutcomeCards(props: { children: ComponentChildren }) {
  return <div class="outcome-cards">{props.children}</div>;
}

export function OutcomeCard(props: {
  industry: string;
  title: string;
  description: string;
  metric?: string;
  metricLabel?: string;
}) {
  return (
    <article class="outcome-card">
      <div class="outcome-card-industry">{props.industry}</div>
      {props.metric && (
        <div class="outcome-card-metric">
          <span class="outcome-card-metric-value">{props.metric}</span>
          {props.metricLabel && <span class="outcome-card-metric-label">{props.metricLabel}</span>}
        </div>
      )}
      <h3 class="outcome-card-title">{props.title}</h3>
      <p class="outcome-card-desc">{props.description}</p>
    </article>
  );
}
